module.exports = __webpack_public_path__ + "img/terroir-tinted-1-mobile.4b64ca14.jpg";